import { createContext, useContext } from 'react'

const PageContext = createContext({})
export const PageProvider = PageContext.Provider

/**
 * @return {Object.<string, PageMetaData>}
 */
export const usePageMetaData = () => {
	const context = useContext(PageContext)
	if (context === undefined) {
		throw new Error('usePageSettings must be used within a PageProvider')
	}
	return context
}
